// returns an element that is used to positionate the given element
// element.offsetParent also gives us `td` elements that we need to skip and find the real offsetParent
function getOffsetParent(element) {
    var offsetPositions = ['absolute', 'fixed', 'relative'];
    var offsetParent = element.offsetParent;
    while (offsetParent && offsetPositions.indexOf(getComputedStyle(offsetParent).position) === -1) {
        offsetParent = offsetParent.offsetParent;
    }
    return offsetParent || window.document.documentElement;
}
// returns the closest scrollable parent
function getOverflowParent(element) {
    var parent = element.parentElement;
    while (parent && getComputedStyle(parent).overflow === 'visible') {
        parent = parent.parentElement;
    }
    return parent;
}
function getWindowPosition() {
    return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function getElementPosition(element) {
    var parentRect = getOffsetParent(element).getBoundingClientRect();
    var viewport = getOverflowParent(element);
    var viewportRect = viewport ? viewport.getBoundingClientRect() : getWindowPosition();
    var targetRect = element.getBoundingClientRect();
    // return viewport and calculated scroll offset with document margins
    return {
        height: targetRect.height,
        width: targetRect.width,
        viewportRect: viewportRect,
        viewportOffset: {
            top: targetRect.top - viewportRect.top,
            left: targetRect.left - viewportRect.left
        },
        scrollOffset: {
            top: targetRect.top - parentRect.top,
            left: targetRect.left - parentRect.left
        }
    };
}
function alignLeftOffset(targetRect, tooltipRect) {
    var tooltipLeftOffset = (targetRect.width - tooltipRect.width) / 2;
    var tooltipViewportOffset = targetRect.viewportOffset.left + tooltipLeftOffset;
    // check that tooltip fits into the visible area from left
    if (tooltipViewportOffset < 0) {
        return 0;
    }
    // check that tooltip fits into the visible area from right
    if (tooltipRect.width + tooltipViewportOffset > tooltipRect.viewportRect.width) {
        return tooltipRect.viewportRect.width - tooltipRect.width;
    }
    return targetRect.scrollOffset.left + tooltipLeftOffset;
}
function alignTopOffset(targetRect, tooltipRect) {
    var tooltipTopOffset = (targetRect.height - tooltipRect.height) / 2;
    // check that tooltip fits into the visible area from top
    if (targetRect.viewportOffset.top + tooltipTopOffset < 0) {
        // actually, this is a scrollTop value
        return targetRect.scrollOffset.top - targetRect.viewportOffset.top;
    }
    return targetRect.scrollOffset.top + tooltipTopOffset;
}
var positionCheck = {
    top: function (targetRect, tooltipRect) {
        return targetRect.viewportOffset.top - tooltipRect.height >= 0;
    },
    bottom: function (targetRect, tooltipRect) {
        return targetRect.viewportOffset.top + targetRect.height + tooltipRect.height < tooltipRect.viewportRect.height;
    },
    right: function (targetRect, tooltipRect) {
        return targetRect.viewportOffset.left + targetRect.width + tooltipRect.width <= tooltipRect.viewportRect.width;
    },
    left: function (targetRect, tooltipRect) {
        return targetRect.viewportOffset.left - tooltipRect.width >= 0;
    }
};
var positionLogic = {
    top: function (targetRect, tooltipRect) {
        return {
            top: targetRect.scrollOffset.top - tooltipRect.height,
            left: alignLeftOffset(targetRect, tooltipRect)
        };
    },
    bottom: function (targetRect, tooltipRect) {
        return {
            top: targetRect.scrollOffset.top + targetRect.height,
            left: alignLeftOffset(targetRect, tooltipRect)
        };
    },
    right: function (targetRect, tooltipRect) {
        return {
            top: alignTopOffset(targetRect, tooltipRect),
            left: targetRect.scrollOffset.left + targetRect.width
        };
    },
    left: function (targetRect, tooltipRect) {
        return {
            top: alignTopOffset(targetRect, tooltipRect),
            left: targetRect.scrollOffset.left - tooltipRect.width
        };
    }
};
export default function positionTooltip(tooltip, target, positions) {
    // reset previous tooltip placement
    tooltip.style.top = '0';
    tooltip.style.left = '0';
    var targetRect = getElementPosition(target);
    var tooltipRect = getElementPosition(tooltip);
    // try to position the tooltip based on the list of positions passed.
    // if the tooltip does not fit after trying all positions listed,
    // default to the first position in the list.
    var position;
    for (var i = 0; i < positions.length; i++) {
        if (positionCheck[positions[i]](targetRect, tooltipRect)) {
            position = positions[i];
            break;
        }
    }
    if (!position) {
        position = positions[0];
    }
    var offsets = positionLogic[position](targetRect, tooltipRect);
    tooltip.style.left = offsets.left + 'px';
    tooltip.style.top = offsets.top + 'px';
    return position;
}
//# sourceMappingURL=positioning.js.map